import { render, staticRenderFns } from "./FormulateAutocomplete.vue?vue&type=template&id=4be56e75"
import script from "./FormulateAutocomplete.vue?vue&type=script&lang=js"
export * from "./FormulateAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports